import { render, staticRenderFns } from "./oilOrderRecord.vue?vue&type=template&id=60d2936e&scoped=true"
import script from "./oilOrderRecord.vue?vue&type=script&lang=js"
export * from "./oilOrderRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d2936e",
  null
  
)

export default component.exports